
<div class="padding-20"></div>
<div class="padding-10"></div>
<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="3%">
  <img src="../../assets/images/BANCOM-Corporate-Hiring.png" fxShow.lt-md="true" fxHide="true" />
  <div fxFlex="50" fxLayoutAlign="center center" class="padding-20">
    <div class="padding-20 text-center">
      <h1 class="mat-display-3">
        Onboard your fresh recruits online, create roadmap for faster
        productivity</h1>
      <p class="mat-headline bold" style="opacity: 0.8">
        A holistic technical learning program for early talent to give them
        valuable skills and confidence in their ability to perform well as a
        product developer.
      </p>
      <br>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
          <div fxFlex="10">&nbsp;</div>
          <div fxFlex="80" class="text-center">
            <span style="margin-right: 1rem">
              <button mat-flat-button color="warn" (click)="openDialog('Salesforce Administration Track')">Request For
                Demo</button>
            </span>
            <span>
              <button mat-flat-button color="warn" routerLink="/contact-us">Contact Us</button>
            </span>
          </div>
          <div fxFlex="10">&nbsp;</div>
        </div>
    </div>
  </div>
  <div fxFlex="50" class="text-center corporate-program" style="text-align: -webkit-center" fxHide.lt-md="true">
  </div>
</div>

<div class="padding-20"></div>
<div class="padding-20"></div>
<div class="padding-20"></div>
<div class="paddingLr-20" style="position: relative; top: -113px">
  <div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
      <div fxFlex="10"></div>
      <div fxFlex="80" class="text-center">
        <div class=" mat-elevation-z8
            padding-10
            highlighted-background-foreground-2">
          <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayout.sm="33%" fxLayoutAlign="center center"
            style="margin-top: 15px">
            <div fxFlex="20" class="text-center">
              <div class="mat-body-1 bold">Developers</div>
              <div class="mat-title bold">65+ million</div>
            </div>
            <div fxFlex="20" class="text-center">
              <div class="mat-body-1 bold">Organizations</div>
              <div class="mat-title bold">3+ million</div>
            </div>
            <div fxFlex="20" class="text-center">
              <div class="mat-body-1 bold">Repositories</div>
              <div class="mat-title bold">200+ million</div>
            </div>
            <div fxFlex="20" class="text-center">
              <div class="mat-body-1 bold">Fortune 50</div>
              <div class="mat-title bold">72%</div>
            </div>
          </div>
        </div>
      </div>
      <div fxFlex="10"></div>
    </div>
  </div>
</div>

<!--<div class="padding-20">
  <mat-divider></mat-divider>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%">
    <div fxFlex="100">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
        <div class="padding-10"></div>

        <div>
          65+ million
          <div style="opacity: 0.6">Developers</div>
        </div>
        <div></div>
        <div>
          3+ million
          <div style="opacity: 0.6">Orgnizations</div>
        </div>
        <div></div>
        <div>
          200+ million
          <div style="opacity: 0.6">Repositories</div>
        </div>
        <div></div>
        <div>
          72%
          <div style="opacity: 0.6">Fortune 50</div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<div>
  <p class="text-center mat-display-2 bold">What You Get?</p>
  <div class="text-center line"></div>
  <div class="padding-20"></div>
  <div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
      <div fxFlex="70" fxFlex.lt-md="60" class="padding-20">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
          <div fxFlex="30">
            <mat-card class="card-1-background card-size cardShadow">
              <div class="padding-7" ngClass.lt-sm="padding-20 padding-10"></div>
              <div class="text-center">
                <img mat-card-image src="../../assets/images/Industry Project img.png"
                  alt="BANCOM Career Planning & Coaching" ngClass.lt-md="unset" style="width: 90%; margin-top: 5px;" />
              </div>
              <div class="padding-10"></div>
              <mat-card-header class="text-center">
                <mat-card-title class="card-Title">
                  <div class="padding-5-top-bottom">
                    Hands-on Industry Projects
                  </div>
                </mat-card-title>
              </mat-card-header>

              <div class="text-center">
                <p>Our developers gain experience by actively participating in industry practices, 
                  project management and user-centric development, rather than simply watching fast-forwarded videos.</p>
                <div class="padding-7"></div>
              </div>
            </mat-card>
          </div>
          <div fxFlex="30">
            <mat-card class="card-2-background card-size cardShadow">
              <div class="padding-7"></div>
              <div class="text-center">
                <img mat-card-image src="../../assets/images/Problem-solving.png"
                  alt="Problem solving Attitude" ngClass.lt-md="unset" style="width:90%; margin-top: 5px;" />
              </div>
              <div class="padding-10"></div>
              <mat-card-header class="text-center">
                <mat-card-title class="card-Title">
                  <div class="padding-5-top-bottom">
                    Problem Solving Attitude
                  </div>
                </mat-card-title>
              </mat-card-header>

              <div class="text-center">
                <p>Our project-based curriculum is designed to expose developers to a diverse
                  production scenarios, providing them with ample opportunities in identifying, analyzing, and resolving 
                  issues.</p>
                <div class="padding-7"></div>
              </div>
            </mat-card>
          </div>
          <div fxFlex="30">
            <mat-card class="card-3-background card-size cardShadow">
              <div class="padding-7"></div>
              <div class="text-center">
                <img mat-card-image src="../../assets/images/Desire to learn.png"
                  alt="BANCOM Referrals and Placement Guarantee" ngClass.lt-md="unset" style="width:90%; margin-top: 5px;" />
              </div>
              <div class="padding-10"></div>
              <mat-card-header class="text-center">
                <mat-card-title class="card-Title">
                  <div class="padding-5-top-bottom">
                    Desire to Learn and Grow
                  </div>
                </mat-card-title>
              </mat-card-header>

              <div class="text-center">
                <p>We understand the importance of comprehensive and immersive learning experiences.
                  That's why our program ensures that developers graduate after completing more than 500 hours of 
                  active project-led learning.</p>
                <div class="padding-7"></div>
              </div>
            </mat-card>
          </div>
        </div>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center"></div>
      </div>
    </div>
  </div>
</div>




<div class="padding-20"></div>
<div class="padding-20"></div>
<p class="text-center mat-display-2 bold">What they learn?</p>
<div class="text-center line"></div>
<div class="padding-20"></div>
<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="5">&nbsp;</div>
  <div fxFlex="90">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center center" class="text-center">
      <div fxFlex="90">
        <img src="../../assets/images/Bancom-Corporate-Hirings-Cirriculam.png" alt="BANCOM Hiring Cirriculam"
          class="review-video-right"/>
        <div class="padding-20"></div>
        <h1 class="heading">
          Curated technical curriculum for entry level developer
        </h1>
        <ul>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon><span
                class="mat-title bold">Practical understanding of Tech Stack</span>
              <div class="body-1">
                <small class="body-1">(Web Serve, Rest API, Caching.etc)</small>
              </div>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Focus on good developer practices</span>
              <div class="body-1">
                <small>(Static Code quality, Unit Testing, Test Mocks, Debugging
                  etc)</small>
              </div>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Familiarity with developers tools</span> &nbsp; &nbsp; &nbsp;
              <div class="body-1">
                <small>(Git, IDE, cURL, Postman etc)</small>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="padding-20"></div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center center" class="text-center">
      <div fxFlex="90">
        <img src="../../assets/images/Bancom-Work-LIke-Product-Exp.png" alt="BANCOM-Work-LIke-Product-Exp"
          class="review-video-left" />
          <div class="padding-20"></div>
        <h1 class="heading">Work-like product building experience</h1>
        <ul>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon><span
                class="mat-title bold">Project based learning through Micro-Experience</span>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Fully provisioned VM, Git Repos, CI setup for
                assessment</span>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Upto 100-150 hours of clearly defined work</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    
    <!-- <div class="padding-20"></div> -->
    <div class="padding-20"></div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center center" class="text-center">
      <div fxFlex="90">
        <img src="../../assets/images/Bancom-Guided-And-Delivery_Assistance.png"
        alt="BANCOM-Guided-And-Delivery_Assistance" class="review-video-right" />
        <div class="padding-20"></div>
        <h1 class="heading">Guided delivery and assistance</h1>
        <ul>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon><span class="mat-title bold">Low
                barrier, Online delivery, Remote Monitoring</span>
              <div class="body-1">
                <small class="body-1">(Web Serve, Rest API, Caching.etc)</small>
              </div>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Remote mentor through slack for project guidance</span>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Daily Standups, Weekly progress status</span>
            </div>
          </li>
          <li>
            <div class="content-align">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Project showcase to engg org</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="padding-10"></div>
  </div>
  <div fxFlex="10">&nbsp;</div>
</div>


<div class="padding-20"></div>
<div class="padding-20"></div>
<p class="text-center mat-display-2 bold">
  Delivered through work-like experiential learning platform
</p>
<div class="text-center line"></div>

<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center"fxHide.lt-md="true">
  <div fxFlex="10">&nbsp;</div>
  <div fxFlex="80">
    <div fxFlex="50">
      <ul style="text-align: left">
        <li>
          <div class="content-align">
            <mat-icon class="bullet-icon">circle</mat-icon>
            <span class="mat-title bold">
              Well defined Work : Micro-experience</span>
            <div class="body-1">
              <small>(PRDs, Tech Docs, Tasks, Milestones, Deadlines)</small>
            </div>
          </div>
        </li>
        <li>
          <div class="content-align">
            <mat-icon class="bullet-icon">circle</mat-icon>
            <span class="mat-title bold"> Project Guidance</span>
            <div class="body-1">
              <small>(Mentor Support from Crio tech leads via slack, Contextual
                help, Community Forum)</small>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div fxFlex="50">
      <ul style="text-align: left">
        <li>
          <div class="content-align">
            <mat-icon class="bullet-icon">circle</mat-icon>
            <span class="mat-title bold">Fully provisioned dev environment</span>
            <div class="body-1">
              <small>(Git workflows, Integrated development environment, Test
                suites, Cloud deployment)</small>
            </div>
          </div>
        </li>
        <li>
          <div class="content-align">
            <mat-icon class="bullet-icon">circle</mat-icon>
            <span class="mat-title bold">
              Engaging to the core</span>
            <div class="body-1">
              <small>(Bancom buddies, Progress Reports, Daily Standups, Memewars
                )</small>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div fxFlex="10">&nbsp;</div>
</div>
<div class="padding-20"></div>
<div class="padding-20"></div>


<!-- <mat-card fxShow.lt-md="true" fxHide="true">
  <ul style="text-align: left">
    <li>
      <div class="content-align padding-10">
        <mat-icon class="bullet-icon">circle</mat-icon>
        <span class="mat-title bold">
          Well defined Work : Micro-experience</span>
        <div class="body-1">
          <small>(PRDs, Tech Docs, Tasks, Milestones, Deadlines)</small>
        </div>
      </div>
    </li>
    <li>
      <div class="content-align padding-10">
        <mat-icon class="bullet-icon">circle</mat-icon>
        <span class="mat-title bold"> Project Guidance</span>
        <div class="body-1">
          <small>(Mentor Support from Crio tech leads via slack, Contextual
            help, Community Forum)</small>
        </div>
      </div>
    </li>
    <li>
      <div class="content-align padding-10">
        <mat-icon class="bullet-icon">circle</mat-icon>
        <span class="mat-title bold">Fully provisioned dev environment</span>
        <div class="body-1">
          <small>(Git workflows, Integrated development environment, Test
            suites, Cloud deployment)</small>
        </div>
      </div>
    </li>
    <li>
      <div class="content-align padding-10">
        <mat-icon class="bullet-icon">circle</mat-icon>
        <span class="mat-title bold">
          Engaging to the coreEngaging to the core</span>
        <div class="body-1">
          <small>(Bancom buddies, Progress Reports, Daily Standups, Memewars
            )</small>
        </div>
      </div>
    </li>
  </ul>
</mat-card> -->
<!-- <div class="padding-20"></div> -->
<div class="padding-10"></div>
<p class="text-center mat-display-2 bold">Developers love learning on Bancom!</p>
<div class="text-center line"></div>
<!-- <div class="padding-20"></div> -->
<div class="padding-10"></div>
<div class="text-center keyhighlights">
  <div class="padding-20"></div>
  <div class="review-section" style="background-color: rgb(165, 241, 135);">
    <div class="review-container">
      <div class="review-content-left">
        <div class="review-title">
          <h1 style="line-height: 50px;">Rajat Kumar</h1>
        </div><br/>
        <span><h3>&nbsp;<b>"</b>&nbsp;BANCOM has been instrumental in opening doors to top IT companies for me. 
          The instructors are highly skilled and their corporate environment fosters
          a culture of continuous growth and achievement.&nbsp;<b>"</b>&nbsp;</h3></span>
      </div>
    <div class="review-video-right">
      <video controls poster="../../../assets/Video/Rajat Thumbnail.png">
        <source src="../../../assets/Video/Rajat's Review.mp4" type="video/mp4">
        Video is not supported!
      </video>
    </div>
    </div>
  </div> 
  
  <div class="padding-20"></div>
  <div class="review-section" style="background-color: rgb(238, 145, 145);">
    <div class="review-container">
      <div class="review-content-right">
        <div class="review-title">
          <h1 style="line-height: 50px;">Abhinav Yaduvanshi</h1>
        </div><br/>
        <span><h3>&nbsp;<b>"</b>&nbsp;Mentorship in BANCOM program has been invaluable in my 
          journey towards becoming a successful Salesforce Administrator. The opportunity to work
          on real-time projects during the course has provided me with invaluable insights
          into the current industry landscape.&nbsp;<b>"</b>&nbsp;</h3></span>
      </div>
    <div class="review-video-left">
      <video controls poster="../../../assets/Video/Rajat Thumbnail.png">
        <source src="../../../assets/Video/Rajat's Review.mp4" type="video/mp4">
        Video is not supported
      </video>
    </div>
    </div>
  </div> 
  <div class="padding-20"></div>
  <div class="review-section" style="background-color: rgb(236, 229, 131);">
    <div class="review-container">
      <div class="review-content-left">
        <div class="review-title">
          <h1 style="line-height: 50px;">Vishwas Aggarwal</h1>
        </div><br/>
        <span><h3><b>"</b>&nbsp;Despite having a bachelor's degree in computer science,
           I lacked confidence in coding. However, Bancom provided me with a platform where I could 
           learn Salesforce and become a Salesforce Developer. I am immensely grateful to BANCOM mentors 
           for giving me this invaluable opportunity.&nbsp;&nbsp;<b>"</b></h3></span>
      </div>
    <div class="review-video-right">
      <video controls poster="../../../assets/Video/Rajat Thumbnail.png">
        <source src="../../../assets/Video/Rajat's Review.mp4" type="video/mp4">
        Video is not supported
      </video>
    </div>
    </div>
  </div> 
</div>



<!-- <div class="padding-20"></div> -->
<div class="padding-20"></div>
<div class="padding-20"></div>
<p class="text-center mat-display-2 bold">
  Ready to onboard your fresh recruits online?
</p>
<div class="text-center line"></div>
<div class="padding-10"></div>
<div class="text-center">
  <img src="../../assets/images/Bancom-Ready-To-Recruit-Onboard.png" alt="Recruitment img" fxHide.lt-md="true"/>
  <img src="../../assets/images/Bancom-Ready-To-Recruit-Onboard.png" alt="Recruitment img" class="recruiter-onboard" fxHide="true" fxShow.lt-md="true" style="width: 100%;" />
</div>
<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="10">&nbsp;</div>
  <div fxFlex="80" class="text-center">
    <span style="margin-right: 1rem">
      <button mat-flat-button color="warn" (click)="openDialog('Salesforce Administration Track')">Request For
        Demo</button>
    </span>
    <span>
      <button mat-flat-button color="warn" routerLink="/contact-us">Contact Us</button>
    </span>
  </div>
  <div fxFlex="10">&nbsp;</div>
</div>
<!-- <div class="padding-20"></div> -->
<div class="padding-10"></div>
<!-- <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="10">&nbsp;</div>
  <div fxFlex="80">
    <p class="text-center mat-display-2 bold">
      Hire your next rockstar product developer
    </p>
    <div class="text-center line"></div>
    <div class="padding-10"></div>
  </div>
  <div fxFlex="10">&nbsp;</div>
</div> -->
<!-- <div class="padding-20"></div> -->
<div class="padding-10"></div>
<!-- <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="10">&nbsp;</div>
  <div fxFlex="80">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center center" class="text-center">
      <div fxFlex="100" style="text-align: center">
        <p class="mat-display-1">
          Curated technical curriculum for entry level developer
        </p>
        <ul>
          <li>
            <div class="content-align padding-10">
              <mat-icon class="bullet-icon">circle</mat-icon><span
                class="mat-title bold">Practical understanding of Tech Stack</span>
              <div class="body-1">
                <small class="body-1">(Web Serve, Rest API, Caching.etc)</small>
              </div>
            </div>
          </li>
          <li>
            <div class="content-align padding-10">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Focus on good developer practices</span>
              <div class="body-1">
                <small>(Static Code quality, Unit Testing, Test Mocks, Debugging
                  etc)</small>
              </div>
            </div>
          </li>
          <li>
            <div class="content-align padding-10">
              <mat-icon class="bullet-icon">circle</mat-icon>
              <span class="mat-title bold">Familiarity with developers tools</span>
              <div class="body-1">
                <small>(Git, IDE, cURL, Postman etc)</small>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
    <div fxFlex="5"></div>
</div> -->
<!-- <div class="padding-20"></div> -->
<!-- <div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="20">&nbsp;</div>
  <div fxFlex="60">
    <p class="text-center mat-display-2 bold">Leader Testimonial</p>
    <div class="text-center line"></div>
  </div>
  <div fxFlex="20">&nbsp;</div>
</div> -->


<!-- <div class="padding-20"></div> -->
<!-- <div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="10">&nbsp;</div>
  <div fxFlex="80"></div>
  <div fxFlex="10">&nbsp;</div>
</div> -->
<!-- <div class="padding-20"></div> -->/




<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" class="text-center">
  <div fxFlex="20">&nbsp;</div>
  <div fxFlex="60">
    <p class="text-center mat-display-2 bold">FAQ's</p>
    <div class="text-center line"></div>
  </div>
  <div fxFlex="20">&nbsp;</div>
</div>
<div class="padding-20"></div>
<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column">
  <div fxFlex="15"></div>
  <div fxFlex="70">
    <mat-accordion>
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title> What is the initial assessment criteria for BANCOM program? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>We conduct an entry-level interview and assignment to assess candidates and provide informed track/cloud 
          recommendations. This helps them make informed decisions about their career path. </p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div fxFlex="15"></div>
</div>
<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column">
  <div fxFlex="15"></div>
  <div fxFlex="70">
    <mat-accordion>
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title> How is this program different from other online courses?  </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          Existing ways of learning - video-based courses or expensive
          bootcamps, don’t provide the real skill development needed.
           Bancom’s project-based learning allows our learners to work on internship-grade 
           projects and multiple hands-on activities in a real developer environment to learn new skills.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div fxFlex="15"></div>
</div>
<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column">
  <div fxFlex="15"></div>
  <div fxFlex="70">
    <mat-accordion>
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title>What types of certificates are provided to BNACOM Learners? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          Learners get a BANCOM Program completion certificate along with a verified GitHub page.
           The GitHub page will be a personalised profile to showcase the details of their work.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div fxFlex="15"></div>
</div>
<div class="padding-10"></div>
<div fxLayout="row" fxLayout.xs="column">
  <div fxFlex="15"></div>
  <div fxFlex="70">
    <mat-accordion>
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title> How can I start hiring from BANCOM? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          Let us know what roles and skillset you’re looking to fill and we'll send you handpicked candidates. 
          You are free to run the candidates through your evaluation process and send us your feedback.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div fxFlex="15"></div>
</div>
<div class="padding-20"></div>
